<app-barra-crud [state]="state" (salvando)="salvar()" (voltando)="busca()" (inserindo)="novo()"
  (editando)="editar()" (excluindo)="excluir()" (cancelando)="cancelar()" [formValido]="f.valid">
</app-barra-crud>
<div class="conteudo cadastro">
  <form role="form" #f="ngForm" novalidate>
    <nav class="topo-abas">
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a id="dados-principais-tab" href="#dados-principais" aria-controls="dados-principais" aria-selected="true"
          class="nav-item nav-link active" data-toggle="tab" role="tab">
          Dados principais
        </a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div id="dados-principais" aria-labelledby="dados-principais-tab" class="tab-pane fade show active"
        role="tabpanel">
        <header class="titulo">Dados Principais</header>
        <div class="container-fluid">
          <div class="row">
            <div class="form-group col-lg-12">
              <small class="form-text text-muted">Campos com (*) são de preenchimento obrigatório.</small>
            </div>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-3" label="ID" name="id_quartil" [(ngModel)]="model.id"
              placeholder="Automático" [ativo]="false"></app-text-box>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-md-12 col-lg-6" label="Descrição" name="descricao"
              [(ngModel)]="model.descricao" obrigatorio="true" required placeholder="Descrição...">
            </app-text-box>
            <app-text-box-data [state]="state" class="col-md-6 col-lg-3" label="Data Inicial" name="dataInicio"
              [(ngModel)]="model.data_inicio" obrigatorio="true" required placeholder="Data de Início...">
            </app-text-box-data>
            <app-text-box-data [state]="state" class="col-md-6 col-lg-3" label="Data Final" name="dataFim"
              [(ngModel)]="model.data_fim" obrigatorio="true" required placeholder="Data de Fim...">
            </app-text-box-data>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>